"use client";

import { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

/** Matches the library's success and loading badges in size and weight. */
export const SigningErrorIcon = ({ children }: Props) => (
	<div className="flex size-12.5 items-center justify-center self-center rounded-full bg-status-error-base text-white shadow-xl">
		{children}
	</div>
);
